import cn from "classnames";
import { Formik, Form } from "formik";

import { CALCULATOR_TYPES } from "constants/calculator";

import { CalculatorFormProps } from "./CalculatorForm.types";

import { getValidationSchema } from "./CalculatorForm.formConfig";

import { ProForm } from "./components/ProForm";
// import { FormHeader } from "./components/FormHeader";
import { ControlsBar } from "./components/ControlsBar";
import { StandardForm } from "./components/StandardForm";
// import { PageMenu } from "components/PageMenu";

// import { tads } from "./CalculatorForm.config";

import styles from "./CalculatorForm.module.scss";

const CalculatorForm = ({
  t,
  className,
  formRef,
  submitLoading,
  defaultDowntimeDynamicNotEmpty,
  isDesktop,
  calculatorType,
  calculationValues,
  loansOptions,
  loans,
  initialValues,
  tabsConfig,
  activeTab,
  stagesOptions,
  onActiveTabChange,
  onKeyDown,
  onCalculationClick,
  // onCalculatorTypeChange,
  // onCalculatorTypeClick,
}: CalculatorFormProps) => (
  <>
    {/* <PageMenu
      title="calculator_form.form_header.title"
      tabs={tads}
      activeTab={calculatorType}
      onTabChange={onCalculatorTypeClick}
      className={styles.pageMenu}
    /> */}
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={getValidationSchema({ calculatorType, t })}
      onSubmit={onCalculationClick}
      validateOnChange
      enableReinitialize
    >
      {({ submitForm }) => (
        <Form
          className={cn(styles.form, className, {
            [styles.formModal]: calculatorType === CALCULATOR_TYPES.LIMITED_PRO,
          })}
          translate="no"
          onKeyDown={(e) => onKeyDown(e, submitForm)}
        >
          {/* {calculatorType !== CALCULATOR_TYPES.LIMITED_PRO && (
          <FormHeader
            calculatorType={calculatorType}
            onCalculatorTypeChange={onCalculatorTypeChange}
            onCalculatorTypeClick={onCalculatorTypeClick}
          />
        )} */}
          {calculatorType !== CALCULATOR_TYPES.BASIC && (
            <ProForm
              isDesktop={isDesktop}
              calculatorType={calculatorType}
              defaultDowntimeDynamicNotEmpty={defaultDowntimeDynamicNotEmpty}
              calculationValues={calculationValues}
              loansOptions={loansOptions}
              loans={loans}
              isRootAdmin={calculatorType === CALCULATOR_TYPES.EXPERT}
              tabsConfig={tabsConfig}
              activeTab={activeTab}
              onActiveTabChange={onActiveTabChange}
              stagesOptions={stagesOptions}
            />
          )}
          {calculatorType === CALCULATOR_TYPES.BASIC && (
            <StandardForm
              isRootAdmin={calculatorType === CALCULATOR_TYPES.EXPERT}
              isDesktop={isDesktop}
              defaultDowntimeDynamicNotEmpty={defaultDowntimeDynamicNotEmpty}
              calculatorType={calculatorType}
              calculationValues={calculationValues}
              loansOptions={loansOptions}
              loans={loans}
              activeTab={activeTab}
            />
          )}
          <div className={styles.separator} />
          <ControlsBar submitLoading={submitLoading} />
        </Form>
      )}
    </Formik>
  </>

);

export default CalculatorForm;
